import { Container, IDestroyOptions, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { gsap } from "gsap";
import { ProfileContainer } from "./ProfileContainer";
import { UserProfileResourcePackage } from "../../../popups/userprofile/resources/UserProfileResourcePackage";
type Timeline = gsap.core.Timeline;

export class ProfileContainerWithHint extends ProfileContainer {
    private static readonly WHOSE_BUILDING_TEXT = "'S BUILDING";
    private static readonly THIS_IS_TEXT = "This is";
    private static readonly BUILDING_TEXT = "Building";

    private hintContainer: Container;
    private hintTextsContainer: Container;
    private hintLeftArrow: Sprite;
    private hintTargetContainer: Container;

    public constructor(
        userProfileResources: UserProfileResourcePackage,
        avatarIcon: Texture,
        firstName: string,
        hintLeftArrowTexture: Texture
    ) {
        super(userProfileResources, avatarIcon, `${firstName}${ProfileContainerWithHint.WHOSE_BUILDING_TEXT}`);
        this.build(firstName, hintLeftArrowTexture);
        this.once("added", this.hideHints.bind(this));
    }

    private build(firstName: string, hintLeftArrowTexture: Texture): void {
        this.hintTargetContainer = new Container();
        this.hintTargetContainer.addChild(this.profileContainer);
        this.addChild(this.hintTargetContainer);
        this.hintContainer = new Container();
        this.addChild(this.hintContainer);
        this.hintTextsContainer = new Container;
        this.hintTextsContainer.angle = -13;
        const firstText = new Text(ProfileContainerWithHint.THIS_IS_TEXT, new HintTextStyle());
        firstText.anchor.set(0.5, 0.5);
        firstText.position.set(-firstText.width * 0.3, -firstText.height * 0.8);
        this.hintTextsContainer.addChild(firstText);
        const firstNameText = new Text(`${firstName}'s`, new HintTextStyle());
        firstNameText.anchor.set(0.5, 0.5);
        this.hintTextsContainer.addChild(firstNameText);
        const buildingText = new Text(ProfileContainerWithHint.BUILDING_TEXT, new HintTextStyle());
        buildingText.anchor.set(0.5, 0.5);
        buildingText.position.set(buildingText.width * 0.3, buildingText.height * 0.8);
        this.hintTextsContainer.addChild(buildingText);
        this.hintContainer.addChild(this.hintTextsContainer);
        this.hintLeftArrow = new Sprite(hintLeftArrowTexture);
        this.hintLeftArrow.anchor.set(1, 0);
        this.hintLeftArrow.angle = -75;
        this.hintLeftArrow.position.set(this.hintTextsContainer.x + this.hintTextsContainer.width * 0.45, this.hintTextsContainer.y - this.hintTextsContainer.height * 0.15);
        this.hintContainer.addChild(this.hintLeftArrow);
        this.hintContainer.position.set(this.hintTargetContainer.x - this.hintTargetContainer.width * 0.6, this.hintTargetContainer.y - this.hintContainer.height * 0.9);
    }

    private hideHints(): void {
        this.hintContainer.visible = false;
    }

    public getHintAnimation(): Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.set(this.hintContainer, { visible: true });
        animationTimeLine.fromTo(this.hintTextsContainer.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.3, ease: "back.out(2)" });
        animationTimeLine.fromTo(this.hintLeftArrow.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.3, ease: "back.out(2)" });
        animationTimeLine.fromTo(this.hintTargetContainer.scale, { x: this.hintTargetContainer.scale.x, y: this.hintTargetContainer.scale.y }, { x: 2, y: 2, duration: 0.3 }, "<");
        animationTimeLine.to(this.hintContainer.scale, { x: 0, y: 0, duration: 0.3, delay: 1, ease: "back.in(2)" });
        animationTimeLine.to(this.hintTargetContainer.scale, { x: 1, y: 1, duration: 0.3 }, "<");
        animationTimeLine.then(() => animationTimeLine.kill());
        return animationTimeLine;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}

class HintTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fontFamily: "Grapenuts Regular",
            fill: "#ffffff",
            fontSize: 76
        }));
    }
}
